import { PageContentSegment } from "./page.model";

export function getDocumentKey(segment: PageContentSegment): string {
	return `${segment.providerId}:${segment.key}`;
}
